import { breakpointsSematic } from '@vueuse/core';

export function useSize() {
    const breakpoints = useBreakpoints(breakpointsSematic);
    const isMobile = ref(true);
    const isDesktop = ref(false);
    const isMobileBreak = breakpoints.smallerOrEqual('tablet');
    const isDesktopBreak = breakpoints.greater('tablet');
    const isMounted = useMounted();
    watchEffect(() => {
        if (isMounted.value) {
            isMobile.value = isMobileBreak.value;
            isDesktop.value = isDesktopBreak.value;
        }
    });
    const isLaptop = breakpoints.greaterOrEqual('laptop');
    return {
        isDesktop,
        isMobile,
        isLaptop,
    };
}
